import permission from "../../managers/vue_extend/permission";

const NotificationInstance = Notification || window.Notification || window.mozNotification || window.webkitNotification;

if(!NotificationInstance){
  const permissionNow = NotificationInstance.permission;
  if(permissionNow === 'granted'){
  //允许通知
  console.log('用户已授权')
  }else{
    setPermission();
  }
}

function setPermission(){
  console.log('请求获取通知权限')
  NotificationInstance.requestPermission(function(PERMISSION){
    if(PERMISSION === 'granted'){
      console.log('用户已授权')
    }else{
      console.log('用户已拒绝')
    }
  });
}

function creatNotifications(content){
  var notification = new NotificationInstance('阿里云--预警消息提醒',{
    body:content,
    icon:'favicon.ico',
    data:{},
    sound:'../static/notify.wav',
    requireInteraction:true,
  });
  notification.onshow =function () {
    playAudio();
    // setTimeout(() =>{
    //   notification.close().bind(notification);
    // },1000*60*60*24*3);
  }
  notification.onclick=function (e) {
    window.open(notification.data.url,'_blank');
    notification.close();
  }
  notification.close=function () {
    setTimeout(() =>{
      notification.close().bind(notification);
    },1000*60*60*3);
  }
  notification.error=function (err) {

  }
}

//播放提示音
const audioElement = document.createElement('audio');
audioElement.setAttribute('src','../static/notify.wav');
function playAudio(){
  audioElement.load;
  audioElement.play();
}

//websocket实时接收后台消息
if(typeof(WeakSet) == 'undefined'){
  console.log('你的浏览器不支持websocket')
}else{

}

class advice{
  static creatNotification(content){
    creatNotifications(content);
    // playAudio()
  }
}

export default advice



// WEBPACK FOOTER //
// ./src/assets/js/notify.js